module.exports = __webpack_public_path__ + "img/1.283f0ae5.svg";